/** Peak envelope of an audio file for drawing a waveform: `bins` values in 0..1 (max absolute sample per bin). */
export function computePeaks(channels: Float32Array[], bins: number): number[] {
  const len = channels[0]?.length ?? 0;
  if (!len || bins < 1) return [];
  const out = new Array<number>(bins).fill(0);
  const size = len / bins;
  for (const ch of channels) {
    for (let b = 0; b < bins; b++) {
      const a = Math.floor(b * size), z = Math.min(len, Math.floor((b + 1) * size));
      let m = 0;
      for (let i = a; i < z; i += Math.max(1, Math.floor((z - a) / 64))) { const v = Math.abs(ch[i]); if (v > m) m = v; }
      if (m > out[b]) out[b] = m;
    }
  }
  return out;
}

/** Decodes a file in the browser and returns its peak envelope; null when the browser cannot decode the format. */
export async function filePeaks(file: File, bins = 600): Promise<number[] | null> {
  try {
    const ctx = new AudioContext();
    try {
      const buf = await ctx.decodeAudioData(await file.arrayBuffer());
      const chans = Array.from({ length: buf.numberOfChannels }, (_, c) => buf.getChannelData(c));
      return computePeaks(chans, bins);
    } finally { void ctx.close(); }
  } catch { return null; }
}

/** afade filter string for a trimmed clip of `length` seconds (empty when no fade). */
export function fadeFilter(fadeIn: number, fadeOut: number, length: number): string {
  const fi = Math.min(Math.max(0, fadeIn), length / 2), fo = Math.min(Math.max(0, fadeOut), length / 2);
  const parts: string[] = [];
  if (fi > 0) parts.push(`afade=t=in:st=0:d=${fi}`);
  if (fo > 0) parts.push(`afade=t=out:st=${Math.max(0, length - fo).toFixed(3)}:d=${fo}`);
  return parts.join(",");
}
